module.exports = __webpack_public_path__ + "img/bunker.7e1be7df.jpg";